export default __webpack_public_path__ + "static/media/1128040325510324.7b80d049.jpg";